import React from 'react'
import styled from 'styled-components'

const Div = styled.div`
  margin-top: -50px;
  width: 100%;
  z-index: -1;
  @media (min-width: 1200px) {
    margin-top: -150px;
  }
`
const Wave = (props, { siteTitle }) => (
  <Div>
    <img
      style={{
        width: '100%',
      }}
      src={props.image}
    />
  </Div>
)

export default Wave



// WEBPACK FOOTER //
// ./src/components/wave/wave.js